import * as React from 'react';
import { connect } from 'react-redux';
import { translate } from 'components/translate-hoc';
import { FriendsReferralApiService } from '@sitegen/common/classes/friends-referral-api';
import { showRewardsImageLightbox } from '../friends-referral/friends-referral-store';
import ProgressBlock from './progress-block.component';
import { IProgressBlockProps } from './progress-block.types';
import { getFRInvitees } from '../../modules/fr-friend-list/fr-friend-list-common/fr-friend-list-common.services';
import { State } from 'widgets/friends-referral/root/root.reducers';

const mapStateToProps = (state: State) => ({
    rewardTiersAssets: state.config.rewardsTiers ?? []
});

const mapDispatchToProps = {
    showRewardsImageLightbox,
};

const ConnectedProgressBlockWithTranslate = connect(
    mapStateToProps,
    mapDispatchToProps
)(translate()(ProgressBlock));

type IState = Pick<IProgressBlockProps, 'loading' | 'rewardTiers' | 'invitees'>;

export default class ProgressBlockContainer extends React.Component<{}, IState> {
    public state: IState = {
        invitees: [],
        rewardTiers: {},
        loading: true,
    };

    public async componentDidMount() {
        const [ rewardTiers, invitees ] = await Promise.all([
            FriendsReferralApiService.getRewardsInfo(),
            getFRInvitees() ]);
            
        this.setState({
            invitees,
            rewardTiers,
            loading: false,
        });
    }

    public render() {
        return <ConnectedProgressBlockWithTranslate 
            loading={ this.state.loading }
            rewardTiers={ this.state.rewardTiers }
            invitees={ this.state.invitees }
        />;
    }
}

export {
    ConnectedProgressBlockWithTranslate
};
